export function getCurrentCommunity(state) {
  return state.communities;
}

export const getCriminalRecordToleranceDays = state => {
  const community = getCurrentCommunity(state);
  return community.settings != null
    ? community.settings.criminalRecordToleranceDays
    : 0;
};

export function getCommunityCoordinates(state) {
  const community = getCurrentCommunity(state);
  return community.location != null
    ? community.location
    : {
        latitude: 0,
        longitude: 0
      };
}

export function getCommunityGates(state) {
  const community = getCurrentCommunity(state);
  return community.gates;
}

export function getSettings(state) {
  const community = getCurrentCommunity(state);
  return community.settings != null
    ? community.settings
    : {
        fines: {
          unitValue: 0,
          unitName: '',
          gracePeriod: 0,
          maxWarnings: 0,
          speedRanges: [],
          history: []
        }
      };
}

export const getLprResidentAccessMatchingEnabled = state => {
  const settings = getSettings(state);
  return settings.lprResidentAccessMatchingEnabled === true;
};

// Morosidad (access suspensions) — spec-front-morosidad-castleblack.md.
// Backend default OFF: with the flag off, applying an episode cuts nothing,
// so the front hides the whole section instead of offering a no-op button.
export const getAccessSuspensionEnabled = state => {
  const settings = getSettings(state);
  return settings.accessSuspensionEnabled === true;
};
